const mockEvents = {
  city: {
    id: 1007700,
    city: 'München',
    lat: 48.14,
    lon: 11.58,
    state: '',
    country: 'de',
    zip: 'meetup3',
    member_count: 1257
  },
  events: [
    {
      created: 1559049792000,
      duration: 9000000,
      id: '261831158',
      name: 'TW presents: AI in the Industry ',
      rsvp_limit: 140,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560875400000,
      local_date: '2020-01-18',
      local_time: '18:30',
      updated: 1559049792000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 137,
      venue: {
        id: 25852478,
        name: 'ThoughtWorks Munich ',
        lat: 48.135372161865234,
        lon: 11.613633155822754,
        repinned: true,
        address_1: 'Bothestraße 11',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1413448074000,
        name: 'ThoughtWorks Munich',
        id: 17658472,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'ThoughtWorks-Muenchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/ThoughtWorks-Muenchen/events/261831158/',
      description: '<p>AI is more than hype - it is here to stay. We are using AI-powered applications every day and companies are experimenting with this technology to find out how additional value can be created with AI. And although the possibilities are endless, they often figure out that the journey from running first promising proofs-of-concept to implementing AI-driven core applications is a difficult one. Becoming a data-driven or AI-driven company is more than building AI driven applications: It requires fundamental changes in how data and knowledge are managed, employees are working together, products are developed and the IT is organized.<br/>In this MeetUp Christoph Windheuser, Global Head of Artificial Intelligence at ThoughtWorks will talk about the current state of AI in the industry illustrated with several project examples.</p> <p>Christoph Windheuser is the Global Head of Artificial Intelligence at ThoughtWorks Inc. Before joining ThoughtWorks, he held several positions at SAP and Capgemini. Before that, he completed his PhD in Neural Networks with a focus on Speech Recognition.</p> <p>AGENDA:<br/>18:30 Snacks, drinks and mingle<br/>19:00 Talk and questions<br/>20:00 More questions, drinks and mingle</p> <p>SNACKS:<br/>As always we are offering various snacks and, beer and soft drinks. No full meal, but at least something to eat.</p> ',
      how_to_find_us: 'The entrance is right next to the entrance of the big bike shop “Stadler”. If you are standing in front of the entrance of Holiday Inn you have to go around the whole building to find our entrance.',
      visibility: 'public'
    },
    {
      created: 1559645940000,
      duration: 10800000,
      id: '262030083',
      name: 'Clean Code Session #35: Pattern Apocalypse',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561654800000,
      local_date: '2020-01-17',
      local_time: '19:00',
      updated: 1559645976000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 40,
      venue: {
        id: 26433928,
        name: 'Carl Zeiss Meditec AG',
        lat: 48.09483337402344,
        lon: 11.52451229095459,
        repinned: true,
        address_1: 'Kistlerhofstraße. 75',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1411685347000,
        name: 'Munich Software Craft Community',
        id: 17214922,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'munich-software-craft-community',
        who: 'Software Crafters',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/munich-software-craft-community/events/262030083/',
      description: '<p>Uncle Bob\'s videos are the classics of the genre. They explain the craft, methods and reasons with absolute clarity. They are a great source of knowledge and motivation to become a cleaner coder. They are entertaining, perfect for the beginners but they also have enough ideas interesting for experienced programmers.</p> <p>The next sessions are dedicated to Design Patterns. We meet on the 27th of June to see episode 34 (<a href="https://cleancoders.com/episode/clean-code-episode-34/show" class="linkified">https://cleancoders.com/episode/clean-code-episode-34/show</a>). "You\'re going to love the discussion about the Bridge pattern. In it, I show you how to break down a subtype hierarchy with multiple degrees of freedom into a chain of several subtype hierarchies capturing one degree of freedom each.</p> <p>In the Chain of Responsibility discussion, we extend those hierarchies so that clients have no idea what server is serving them.</p> <p>Then we explore Greenspun\'s 10th Law by looking at the Interpreter pattern. And we learn that with great power comes great responsibility, and that most efforts to reduce programming workload by shifting it to the business simply cause that workload to bounce back to the programmers.</p> <p>You\'re going to find the Iterator discussion particularly interesting. It\'s not what you think it is. This discussion will teach you how to turn loops inside out so that the loops are at the bottom, being driven by the algorithm, instead of at the top and driving the algorithm.</p> <p>And then, at long last, the humble Adapter pattern. I\'ll go through a little history about comp.object discussions, table lamps, and interface naming. And then we\'ll explore the two primary forms of the Adapter. "</p> <p>This time the meetup is hosted and sponsored by Carl Zeiss Meditec AG (<a href="https://www.zeiss.de/meditec-ag/ueber-uns/standorte/deutschland-muenchen.html" class="linkified">https://www.zeiss.de/meditec-ag/ueber-uns/standorte/deutschland-muenchen.html</a>).</p> ',
      visibility: 'public'
    },
    {
      local_time: '18:00',
      local_date: '2020-01-16',
      link: 'https://www.meetup.com/Munchen-Soccer-Meetup/events/261960274/',
      visibility: 'public_limited',
      group: {
        created: 1498592776000,
        name: 'Munich Thursday\'s football sessions',
        id: 24709259,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munchen-Soccer-Meetup',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 0,
      yes_rsvp_count: 12,
      duration: 7200000,
      time: 1559836800000,
      utc_offset: 7200000,
      name: 'Football at Lindwurmstrasse - 6 June 2019',
      id: '261960274'
    },
    {
      created: 1557309425000,
      duration: 10800000,
      id: '261282757',
      name: '6th Apache Flink Munich Meetup at Amazon',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1562256000000,
      local_date: '2020-01-014',
      local_time: '18:00',
      updated: 1558447161000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 42,
      group: {
        created: 1446634146000,
        name: 'Apache Flink Meetup Munich',
        id: 19089466,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Apache-Flink-Meetup-Munich',
        who: 'Squirrels',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Apache-Flink-Meetup-Munich/events/261282757/',
      description: '<p>Save the date for the next Flink meetup in Munich hosted by AWS on July 4th! Join for exciting talks, networking, and pizza &amp; beer.</p> <p>Agenda:</p> <p>6:00 pm - Food &amp; networking<br/>6:30 pm - Talk #1 by Steffen Hausmann, AWS: "Build and run streaming applications with Apache Flink and Amazon Kinesis Data Analytics for Java Applications"<br/>7:00 pm - Talk #2 by Michel Davit, Ryte: "Building a high-performance crawler: a streaming use case with Apache Flink &amp; AWS"<br/>7:30 pm - 9:00 pm Networking</p> <p>Talk #1: Build and run streaming applications with Apache Flink and Amazon Kinesis Data Analytics for Java Applications by Steffen Hausmann, AWS</p> <p>Stream processing facilitates the collection, processing, and analysis of real-time data and enables the continuous generation of insights and quick reactions to emerging situations. Yet, despite these advantages compared to traditional batch-oriented analytics applications, streaming applications are much more challenging to operate. Some of these challenges include the ability to provide and maintain low end-to-end latency, to seamlessly recover from failure, and to deal with a varying amount of throughput.</p> <p>We all know and love Flink to take on those challenges with grace. In this session, we explore an end to end example that shows how you can use Apache Flink and Amazon Kinesis Data Analytics for Java Applications to build a reliable, scalable, and highly available streaming applications. We discuss how you can leverage managed services to quickly build Flink based streaming applications and show managed services can help to substantially reduce the operational overhead that is required to run the application. We also review best practices for running streaming applications with Apache Flink on AWS.</p> <p>So you will not only see how to actually build streaming applications with Apache Flink on AWS, you will also learn how leveraging managed services can help to reduce the overhead that is usually required to build and operate streaming applications to a bare minimum.</p> <p>Talk #2: Building a high-performance crawler: a streaming use case with Apache Flink &amp; AWS by Michel Davit, Ryte</p> <p>Ryte is undergoing its digital transformation, conducting to a complete redesign of the in-house web crawler. You’ll see how moving from a batch/worker setup to an Apache Flink streaming application, combined with various Amazon Services, helps to reach performance, reliability and scalability goals.</p> <p>You’ll also be given some development and operation insights to better dimension containers, configure checkpointing and avoid class loader leakage.</p> <p>------------------------------------------------------------------------------------------------------</p> <p>As always, feel free to invite your colleagues and friends and share the meetup with your network!</p> ',
      visibility: 'public'
    },
    {
      local_time: '19:00',
      local_date: '2020-01-16',
      link: 'https://www.meetup.com/rice-cookie-improv/events/flrdzqyzjbjb/',
      visibility: 'public_limited',
      group: {
        created: 1468649601000,
        name: 'Rice Cookie Improvtheater in Munich',
        id: 20189476,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'rice-cookie-improv',
        who: 'Improv-Enthusiasts',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 0,
      yes_rsvp_count: 12,
      duration: 7200000,
      time: 1559840400000,
      utc_offset: 7200000,
      name: 'Workshop: Get loose with Improv Theater',
      id: 'flrdzqyzjbjb'
    },
    {
      created: 1556890040000,
      duration: 7200000,
      id: '261134703',
      name: '15. Treffen der Gruppe Software Architektur München',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560789000000,
      local_date: '2020-01-17',
      local_time: '18:30',
      updated: 1556890341000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 76,
      venue: {
        id: 25881465,
        name: 'TNG Technology Consulting GmbH',
        lat: 48.15310287475586,
        lon: 11.616222381591797,
        repinned: true,
        address_1: 'Arabellastraße 4a',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1473607978000,
        name: 'Software Architektur München',
        id: 20413739,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Software-Architektur-Muenchen',
        who: 'Software-Gestalter',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Software-Architektur-Muenchen/events/261134703/',
      description: '<p>Liebe Mitglieder der Meetup-Gruppe Software Architektur München,</p> <p>unser nächstes Treffen steht an und wir freuen uns sehr, dass wir hierfür Eberhard Wolff gewinnen konnten:</p> <p>Vortrag: Wie werde ich ein erfolgreicher Software-Architekt?</p> <p>Sprecher: Eberhard Wolff, Fellow bei INNOQ</p> <p>Software-Architektur ist ganz einfach: Eigentlich muss man nur ein<br/>System aufteilen und moderne Ansätze wie DDD oder Microservices nutzen.<br/>Diese Präsentation zeigt völlig andere Voraussetzungen, die ein guter<br/>Software-Architekt mitbringen muss. Im Mittelpunkt stehen die<br/>technischen Entscheidungen, die ein Architekt treffen muss, wie man am<br/>besten mit solchen Entscheidungen umgeht und wie man herausfindet, auf welcher Basis man die Entscheidungen treffen kann. Und weil Software-Projekte immer im Team stattfinden, geht es natürlich auch um<br/>Soft Skills und den Umgang mit den Teams.</p> <p>Eberhard Wolff ist Fellow bei INNOQ und arbeitet seit mehr als fünfzehn<br/>Jahren als Architekt und Berater, oft an der Schnittstelle zwischen<br/>Business und Technologie. Er ist Autor zahlreicher Artikel und Bücher,<br/>u.a. zu Continuous Delivery und Microservices und trägt regelmäßig als<br/>Sprecher auf internationalen Konferenz vor. Sein technologischer<br/>Schwerpunkt sind moderne Architektur- und Entwicklungsansätze wie Cloud, Continuous Delivery, DevOps und Microservices.</p> <p>Wir werden uns am 17. Juni 2019 um 18:30 Uhr in den Räumen von TNG Technology Consulting GmbH in der Arabellastraße treffen:</p> <p>Arabellastraße 4a<br/>81925 München</p> <p>Für Getränke und Essen ist gesorgt.</p> ',
      how_to_find_us: 'https://www.tngtech.com/tng-ueber-uns/anfahrt.html#c20978',
      visibility: 'public'
    },
    {
      created: 1557474102000,
      duration: 10800000,
      id: '261344995',
      name: 'June Meetup @Google',
      rsvp_limit: 120,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559838600000,
      local_date: '2020-01-16',
      local_time: '18:30',
      rsvp_open_offset: 'PT336H',
      updated: 1559742856000,
      utc_offset: 7200000,
      waitlist_count: 25,
      yes_rsvp_count: 120,
      venue: {
        id: 26112492,
        name: 'Google',
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: 'Erika-Mann-Straße 33',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1396731662000,
        name: 'GDG Munich Gophers',
        id: 13747262,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-Gophers-Go-User-Group',
        who: 'Gophers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munich-Gophers-Go-User-Group/events/261344995/',
      description: '<p>Join us for the June edition of the Munich Gophers Meetup at Google.</p> <p>Speakers:<br/>---------------<br/>• Talk 1: The Story of How and Why Uber is Using Go (Lena Morozova, Uber - Live from San Francisco, Thanks @Lena!)<br/>• Talk 2: GoLand: Behind the Scenes (Artem Khvastunov, Jetbrains)</p> <p>Agenda: TBD:<br/>---------------</p> <p>About The Speakers:</p> <p>Lena Morozova from Uber will tell the story of how Go went from being used by a few enthusiastic developers at Uber to becoming the most popular language for microservices in use there. She\'ll talk about how they started and why they decided to use Go.</p> <p>Some of the tips she\'ll address include:<br/>• Dependency injection<br/>• Consistent code structure<br/>• Custom solutions: Fx and Glue<br/>• Monorepo</p> <p>Come learn where they failed and how that led them to solutions that they think are pretty darn neat.</p> <p>Lena Morozova is a software engineer at the Go Platform Team at Uber where she works on Uber\'s Go ecosystem and wants to make Go experience more enjoyable at Uber. She is a co-organizer of the Women Who Go San Francisco meetup. She is excited about Go, hiking, and dancing.</p> <p>Artem Khvastunov from Jetbrains will give us a behind-the-scenes look into GoLand. We live in a rapidly changing world. Every year Apple releases new macOS, Google ships Go once in six months, every five seconds Boeing 737 departs or lands, and once in a second a new JS framework appears or dies. It\'s a challenge to promptly adapt to all the changes and preserve quality at the same time. In this talk, I\'ll speak about processes and tools GoLand team uses to release a new version of the IDE every four months.</p> <p>Some quick facts about Artem:<br/>- Software developer at JetBrains<br/>- Works on GoLand for more than a year<br/>- Previously worked on PhpStorm<br/>- Loves outdoor activities like hiking, biking, and snowboarding<br/>- Lives in Munich, Germany</p> ',
      visibility: 'public',
      pro_is_email_shared: false
    },
    {
      created: 1536308315000,
      duration: 30600000,
      fee: {
        accepts: 'cash',
        amount: 20,
        currency: 'EUR',
        description: 'per person',
        label: 'Price',
        required: false
      },
      id: 'tcdgfqyzjbjb',
      name: 'Drupal Coworking Day',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559804400000,
      local_date: '2020-01-16',
      local_time: '09:00',
      updated: 1536308315000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 0,
      venue: {
        id: 19782872,
        name: 'WERK1',
        lat: 48.12442398071289,
        lon: 11.607309341430664,
        repinned: true,
        address_1: 'Grafinger Straße 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1410086988000,
        name: 'München Drupal User Group Meetup',
        id: 16845232,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munchen-Drupal-User-Group-Meetup',
        who: 'Drupalistas',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munchen-Drupal-User-Group-Meetup/events/tcdgfqyzjbjb/',
      description: '<p>Wir treffen uns einmal im Monat zu einem ungezwungen Coworking-Tag. Jeweils am ersten Donnerstag im Monat bietet uns dafür das Werk1 eine schöne Atmosphäre um uns in die Arbeit zu vertiefen aber auch nebenbei über Drupal-nahe und -fremde Themen zu sprechen.</p> <p>Format:<br/>An dem Tag soll für jeden die eigene Arbeit im Vordergrund stehen. Es soll aber gleichtzeitig dazu dienen einen Rahmen zu schaffen in dem man unkompliziert über konkrete Probleme oder interessante Ideen sprechen kann, oder einfach gemeinsam bei einem Kaffee über alltägliches, Webentwicklung und Drupal philosophieren kann.</p> <p>Zielgruppe:<br/>Jede und jeder Drupal-Enthusiast oder -Interessierte. Gerne auch Quereinsteiger, Hobbyisten, Entwickler, Designer, Frontender, Gründer oder Nutzer anderer Technoligie wie Wordpress, Typo3, Joomla, Symfony, React, Angular, ... . Hauptsache nette Leute.</p> <p>Räumlichkeiten:<br/>Im Coworking-Bereich "Communication Space" stehen Arbeitsplätze zur Verfügung. Im danebenliegenden Café mit ausreichend Sitzgelegenheiten können zudem Getränke und Speisen erworben werden.</p> <p>Kosten:<br/>Im Werk1 kann man für 20€ einen Tagespass fürs Coworking buchen. Die Abrechnung erfolgt direkt über das Werk1 vor Ort. Siehe <a href="https://www.werk1.com/coworking/" class="linkified">https://www.werk1.com/coworking/</a></p> ',
      how_to_find_us: 'Eingang zum Coworking-Berech "Communication Space" über das Werk1.Café',
      visibility: 'public'
    },
    {
      created: 1553803113000,
      duration: 10800000,
      id: '260154719',
      name: 'Built with Flutter - Share your Flutter story',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1564675200000,
      local_date: '2020-01-18',
      local_time: '18:00',
      updated: 1558200667000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 44,
      venue: {
        id: 26112492,
        name: 'Google',
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: 'Erika-Mann-Straße 33',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1543101111000,
        name: 'Flutter Munich',
        id: 30587470,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Flutter-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Flutter-Munich/events/260154719/',
      description: '<p>🏰Have you built something with Flutter? This is the time to show it to the world! This event is focussing on Flutter stories. You can share what you created with Flutter and how your experience was.</p> <p>🚀We would like to hear about your personal pet projects, your work for a client or your company or open source libraries. The talks should be a good mixture of Flutter, technology, your product or service, your team, an overview of the greatest challenges along the way and a good story. You can share with us why you used Flutter, how you used it and what you built as long as you can do it in 11 minutes.</p> <p>🎤Would you like to present? Please contact me if you, your company or your team is working on something awesome and using Flutter made shipping something great possible and you would like to share your story with us.</p> <p>🍻We are going to have 5+ short Flutter stories.</p> <p>👩\u200d🎓🕺👩\u200d💻This event will not focus heavily on coding, so feel free to invite your product owner, designer or entrepreneur friends. We have an attendee limit of 100 people. 💃👷💂\u200d♀️</p> <p>LOCATION</p> <p>📍The event\'s location: Isar Valley @ Google Munich</p> <p>PRESENTATIONS</p> <p>🎤 Stefan Schaller and Julian Bissekkou from Tikkr 🎤<br/>Tikkr is a time tracking tool for small startups and freelancers. You can create and track tasks. You always have an overview of your time and statistics.<br/>Tikkr is a team of three: Stefan, Julian (mobile developers) and Tobi (web developer). They also develop a web app in AngularDart, this enables them to share code between the web and mobile app.<br/><a href="https://tikkr.app" class="linkified">https://tikkr.app</a></p> <p>🎤Wolfgang Strunk from SV Pullach/iteratec 🎤<br/>Have you ever built an app for a non-profit organization? The SV Pullach App lets you figure out the next games, insert them to your calendar, search for match locations and get overall team information.<br/>A no longer maintained iOS App was the trigger for a rebuild of the outdated Android App. Flutter\'s cross-platform approach allowed to give it a try, backed by Wolfgang\'s personal 5 day budget for innovation projects.</p> <p>CONTRIBUTE:</p> <p>🗣️ If you\'d like to present, please read <a href="https://github.com/flutter-munich/built-with-flutter" class="linkified">https://github.com/flutter-munich/built-with-flutter</a></p> <p>🍕 Would you or your company like to host one of our upcoming events? Send me a message!</p> ',
      how_to_find_us: 'Isar Valley @ Google Munich. Get your badge at the lobby, we\'ll be there to show you where the event space is.',
      visibility: 'public'
    },
    {
      created: 1559295251000,
      duration: 7200000,
      id: '261923444',
      name: 'Episode 47 – Lean Innovation at Deutsche Bahn',
      rsvp_limit: 80,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560445200000,
      local_date: '2020-01-13',
      local_time: '19:00',
      updated: 1559302575000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 60,
      venue: {
        id: 25766778,
        name: 'AutoScout24 (new office)',
        lat: 48.1358642578125,
        lon: 11.613330841064453,
        repinned: true,
        address_1: 'Bothestraße 11 - 15',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1328897556000,
        name: 'Lean Startup München (Munich)',
        id: 3270542,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Lean-Startup-Munich',
        who: 'Practicioners',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Lean-Startup-Munich/events/261923444/',
      description: '<p>It\'s been almost a year since I hopped on a train in Mannheim heading west. My travel app from Deutsche Bahn suddenly surprised me by offering a "comfort check-in" that freed me from having to show my ticket.</p> <p>I then noticed two further things: The feature was in test mode as I didn\'t find it on any other train connection I used. And even more surprisingly, the ticket inspectors were all very well aware of this new digital functionality and while they checked all other passengers\' tickets, I could keep working, reading or even sleeping undisturbed. Over the past months, I\'ve seen the functionality evolve in user experience. The whole thing feels like a perfect implementation of the Lean Innovation Playbook :-)</p> <p>So, here\'s our highlight talk for this months (unusually scheduled) Lean Startup Meetup:</p> <p>Lean Innovation at Deutsche Bahn - Marc Balzerowski &amp; Jan Berg</p> <p>Imagine you are a giant organization running services for basically everyone living in or travelling to Germany. Your organization is composed of specialized suborganizations (e.g. long-distance travel vs. local traffic) that each have their own history and legacy. And your job is to innovate in that environment as if you were a startup.</p> <p>Marc and Jan are going to share how they have successfully created customer value with a customer-centric and test-driven approach from early testing to scaling it further.</p> <p>....and - as always - you will meet other lean startup practitioners and find a great network to share your own experiences :-)</p> ',
      visibility: 'public'
    },
    {
      created: 1556020226000,
      duration: 7200000,
      id: '260849718',
      name: 'AfterWERK meets Munich Startup',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561651200000,
      local_date: '2020-01-17',
      local_time: '18:00',
      updated: 1558445531000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 67,
      venue: {
        id: 19782872,
        name: 'WERK1',
        lat: 48.12442398071289,
        lon: 11.607309341430664,
        repinned: true,
        address_1: 'Grafinger Straße 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 19716609,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/260849718/',
      description: '<p>Once per month the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself write to [masked].</p> <p>In a nutshell<br/>– Thursday, 27th June 2019 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 5 minutes each</p> ',
      how_to_find_us: 'access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: 'public'
    },
    {
      local_time: '19:00',
      local_date: '2020-01-13',
      link: 'https://www.meetup.com/rice-cookie-improv/events/flrdzqyzjbrb/',
      visibility: 'public_limited',
      group: {
        created: 1468649601000,
        name: 'Rice Cookie Improvtheater in Munich',
        id: 20189476,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'rice-cookie-improv',
        who: 'Improv-Enthusiasts',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 0,
      yes_rsvp_count: 5,
      duration: 7200000,
      time: 1560445200000,
      utc_offset: 7200000,
      name: 'Workshop: Get loose with Improv Theater',
      id: 'flrdzqyzjbrb'
    },
    {
      created: 1559192857000,
      duration: 10800000,
      id: '261889529',
      name: 'C++11 was only the beginning',
      rsvp_limit: 110,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561482000000,
      local_date: '2020-01-15',
      local_time: '19:00',
      rsvp_open_offset: 'PT336H',
      updated: 1559538505000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 5,
      venue: {
        id: 26423626,
        name: 'Austin Fraser GmbH',
        lat: 48.141048431396484,
        lon: 11.566612243652344,
        repinned: true,
        address_1: 'Lenbachplatz 1',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1381869297000,
        name: 'MUC++',
        id: 10704512,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MUCplusplus',
        who: 'C++ aficionados',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MUCplusplus/events/261889529/',
      description: '<p>On June, 25th, we have the great honour to welcome Mateusz Pusz to our user group. Mateusz is a software architect, chief engineer, and security champion with more than 15 years of experience in designing, writing and maintaining C++ code for fun and living. He is also a contributor and an active voting member of the ISO C++ Committee (WG21) where, together with the best C++ experts in the world, he shapes the future of the C++ language.</p> <p>Abstract:<br/>C++ is the fastest programming language in the world, and it leaves no room for other languages below it (except assembler). That is why it gets more attention now than ever before. As a result, we observe an increasing speed of the C++ language evolution. C++11 was a game changer, but now it is considered an "old" language already. C++14 and C++17 provided many improvements that allow us to write portable, safer, and faster programs in a shorter time. The resulting source code is easier to reason about and maintain. Moreover, the C++20 is coming soon, and it is going to be a game changer again.</p> <p>In my talk, I provide a few typical legacy code examples that most of us write every day. I describe how those samples evolve with the changes introduced in the subsequent C++ language releases ranging from C++11 up to the major groundbreaking features of upcoming C++20. During the talk, the audience will learn how much easier, more robust, and safer is the code written using modern tools that we get with every new C++ release.</p> <p>Schedule:<br/>19:00 -- Welcome with Pizza and Drinks<br/>19:30 -- Welcome at Austin Fraser<br/>19:40 -- Lightning Talk<br/>19:50 -- Main talk by Mateusz Pusz<br/>~21:00 -- Open Discussions<br/>22:00 -- Official End</p> <p>Sponsor: Austin Fraser (<a href="https://www.austinfraser.com/en/" class="linkified">https://www.austinfraser.com/en/</a>)</p> ',
      visibility: 'public'
    },
    {
      created: 1559539790000,
      duration: 10800000,
      id: '261994872',
      name: 'Teaching geometry to C++',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1563814800000,
      local_date: '2020-01-15',
      local_time: '19:00',
      rsvp_open_offset: 'PT504H',
      updated: 1559577495000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      group: {
        created: 1381869297000,
        name: 'MUC++',
        id: 10704512,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MUCplusplus',
        who: 'C++ aficionados',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MUCplusplus/events/261994872/',
      description: '<p>This month we have the great honour to welcome Guy Davidson to our user group. Guy has been writing games for a variety of hardware for about 40 years now, the last 20 at Creative Assembly, makers of the Total War franchise, where he is now the Principal Coding Manager. He is an active participant of the C++ standard committee, and a regular speaker at CppCon, ACCU, Meeting C++, and meetups around Europe.</p> <p>Abstract:<br/>As the linear algebra proposal takes shape, I would like to speculate about the next piece of maths to teach to C++. With linear algebra in place, it will be possible to introduce analytical geometry. This talk will briefly cover the proposed linear algebra classes and how they can be used to create geometry classes. We\'ll look at matrix and vector specialisation, lines, curves, polygons, polyhedra, intersection, and the ghastly role played by five orders of precision.</p> <p>Schedule:<br/>19:00 -- Welcome with Snacks and Drinks<br/>19:30 -- Welcome at TTTech<br/>19:40 -- Lightning Talk<br/>19:50 -- Main talk by Guy Davidson<br/>~21:00 -- Open Discussions<br/>22:00 -- Official End</p> <p>Sponsor: TTTech (<a href="https://www.tttech-auto.com" class="linkified">https://www.tttech-auto.com</a>)</p> ',
      visibility: 'public'
    },
    {
      created: 1556020305000,
      duration: 7200000,
      id: '260849735',
      name: 'AfterWERK meets Munich Startup',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1564070400000,
      local_date: '2020-01-15',
      local_time: '18:00',
      updated: 1558445578000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 27,
      venue: {
        id: 19782872,
        name: 'WERK1',
        lat: 48.12442398071289,
        lon: 11.607309341430664,
        repinned: true,
        address_1: 'Grafinger Straße 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 19716609,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/260849735/',
      description: '<p>Once per month the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself write to [masked].</p> <p>In a nutshell<br/>– Thursday, 25th July 2019 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 5 minutes each</p> ',
      how_to_find_us: 'access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: 'public'
    },
    {
      created: 1558510271000,
      duration: 7200000,
      id: '261667492',
      name: 'Meeting Lech Route ',
      rsvp_limit: 20,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1562864400000,
      local_date: '2020-01-15',
      local_time: '19:00',
      updated: 1558561127000,
      utc_offset: 7200000,
      waitlist_count: 1,
      yes_rsvp_count: 21,
      group: {
        created: 1389721197000,
        name: 'Hiking near Munich',
        id: 12113182,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Hiking-near-Munich',
        who: 'Munich hikers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Hiking-near-Munich/events/261667492/',
      description: '<p>This is a relaxed meeting for everyone interested in joining the longer hike in August/September.</p> <p>A perfect opportunity to get to know each other, to talk routes and accommodation and just have dinner.</p> <p>I will announce the location a little closer to the event and will then make a reservation if possible.</p> ',
      visibility: 'public'
    },
    {
      created: 1557248390000,
      duration: 7200000,
      id: 'ktcvxqyzjblb',
      name: 'Shut Up & Write!™ Munich',
      rsvp_limit: 12,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559979000000,
      local_date: '2020-01-15',
      local_time: '09:30',
      rsvp_open_offset: 'PT163H30M',
      updated: 1557248390000,
      utc_offset: 7200000,
      waitlist_count: 6,
      yes_rsvp_count: 12,
      venue: {
        id: 25966475,
        name: 'Bellevue München',
        lat: 48.160736083984375,
        lon: 11.563915252685547,
        repinned: false,
        address_1: 'Schleißheimer Str. 142a',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1532540208000,
        name: 'Shut Up & Write!® Munich',
        id: 29351354,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'shutupandwritemunich',
        who: 'Writers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/shutupandwritemunich/events/ktcvxqyzjblb/',
      description: '<p>Join us for an hour of writing! We’ve discovered that it’s strikingly helpful to write with other writers. See if it’s true for you at 09:30 on Saturday.</p> <p>Be it a book, blog, script, essay, dissertation, resume, melody, poem or just plain work stuff, you are invited to write it with us. No one will see what you\'ve written or give you unsolicited advice. Instead of just thinking about writing, come and get some real writing done.<br/>SCHEDULE:<br/>09:30 - SESSION 1: quick intros.<br/>09:45 - timer starts: write for 1 hour.<br/>10:45 - chat / take off / keep writing for another timed hour (starting at ~11:15).</p> <p>OPTIONAL SOCIALIZING happens after we\'re done with the first/second writing hour. Writing is very solitary. Connecting (and sometimes even commiserating) with other writers is a cool thing.<br/>BEING LATE IS OKAY: just show up and get settled, then check-in with me after the session. (I’ll be the person with the Shut Up &amp; Write! sign.) If you were on time, please be willing to make room for the friendly latecomer.<br/>Happy writing and I look forward to seeing you!</p> <p>What Should I Bring?<br/>Whatever you need to be able to write!<br/>Bring earbuds/earplugs if you want to block the cafe’s overhead music or the occasional conversation by other patrons.<br/>There should be enough sockets to charge your devices, but make sure to charge them just in case! :)</p> <p>Other Important Details:<br/>GUIDELINES: Please thank our hosts by purchasing something.<br/>FUTURE LOCATIONS: If you have ideas about where and when we should meet, please share them! :)<br/>If you\'re on the waiting list, but still really really want to come, feel free to drop by — but in case we end up being too large of a group to manage, or we don\'t find enough free seats, the priority is on the folks with the \'going\' RSVPs!</p> ',
      how_to_find_us: 'Look for the Shut up & Write! sign or ask for Arnaud ',
      visibility: 'public',
      pro_is_email_shared: false
    },
    {
      created: 1558563673000,
      duration: 10800000,
      id: '261686211',
      name: 'Vue.js MeetUp',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560443400000,
      local_date: '2020-01-15',
      local_time: '18:30',
      updated: 1559120997000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 96,
      venue: {
        id: 26377974,
        name: 'xbAV AG',
        lat: 48.14632034301758,
        lon: 11.537505149841309,
        repinned: true,
        address_1: 'Arnulfstraße 126',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1509975972000,
        name: 'Vue.js Munich',
        id: 26512656,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Vue-js-Munich',
        who: 'Vuers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Vue-js-Munich/events/261686211/',
      description: '<p>18:30 Food, Drinks, Social</p> <p>19:00 Welcome</p> <p>[30min] Modern Web Applications with Vue.js &amp; GraphQL, Marion Schleifer</p> <p>[15min] Break — Food, Drinks, Social</p> <p>[50min] Animations with Vue.js &amp; Nuxt.js, Samuel Snopko</p> <p>[10min] TICKET GIVEAWAY thanks to our friends @ <a href="https://www.worker.sh/" class="linkified">https://www.worker.sh/</a> ❣️</p> <p>Location, food &amp; drinks sponsored by xbAV AG. ❣️</p> <p>--- --- ---</p> <p>Modern Web Applications with Vue.js &amp; GraphQL, @rubydwarf</p> <p>We will learn how to build serverless applications with Hasura’s GraphQL engine as a backend and Vue.js as a front–end. We’ll see how to take advantage of the combination of these technologies by building a sample application.</p> <p>I’m a community organizer and freelance software developer in Zurich. Recently, I have discovered the power of GraphQL and started building web applications with Hasura’s GraphQL engine in combination with Vue.js. My side project is a GraphQL Harry Potter API that I use in combination with Vue.js.</p> <p>--- --- ---</p> <p>Animations with Vue.js &amp; Nuxt.js, @SamuelSnopko</p> <p>Have you ever wonder how to tackle all the animations, that are recently popping on the web? How to animate on scroll or create pretty smooth transitions between different subpages of your web app? If yes, then I will try to answer some of your questions. I will show how to tackle basic to advanced animations in Vue.js/Nuxt.js. I will also present it on my recent projects, so you will see more code than slides. Sneak peek of what I am talking about: <a href="https://advertorial.sueddeutsche.de/adobe/" class="linkified">https://advertorial.sueddeutsche.de/adobe/</a></p> <p>Creative FrontEnd Knight &amp; DesignOps enthusiast with a passion for JAMStack and beautiful web. Co-creator of DX Meetup Basel and co-organizer of Frontend Meetup Freiburg. Recently fell in love with Vue.js, Nuxt.js, and Storyblok.</p> ',
      visibility: 'public'
    },
    {
      created: 1554410956000,
      duration: 10800000,
      id: '260351816',
      name: 'MeasureBowling #11 in Munich',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560445200000,
      local_date: '2019-06-13',
      local_time: '19:00',
      updated: 1554476870000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 11,
      group: {
        created: 1543785470000,
        name: 'München Digital Analytics Meetup',
        id: 30635499,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munchen-Web-Analytics-Meetup',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munchen-Web-Analytics-Meetup/events/260351816/',
      description: '<p>Happy to announce, that the 11th edition of MeasureBowling will take place on June 13th, 2019, also in Munich. Don\'t miss the opportunity to join this annual social activity event of the digital analytics community in Munich.</p> <p>----IMPORTANT-----</p> <p>To join this event, buy a 15 EUR ticket here: <a href="https://www.xing.com/events/2085119" class="linkified">https://www.xing.com/events/2085119</a></p> <p>Welcome drink and two hours of bowling included in the ticket.<br/>-------------------------</p> <p>Agenda:</p> <p>07:00 pm: Admission and Welcome<br/>07:30 pm: Introduction &amp; Preparation<br/>08:00 pm: Bowling<br/>10:00 pm: Prize-Award Ceremony</p> ',
      visibility: 'public'
    },
    {
      local_time: '19:00',
      local_date: '2019-06-11',
      link: 'https://www.meetup.com/rice-cookie-improv/events/zkrdzqyzjbpb/',
      visibility: 'public_limited',
      group: {
        created: 1468649601000,
        name: 'Rice Cookie Improvtheater in Munich',
        id: 20189476,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'rice-cookie-improv',
        who: 'Improv-Enthusiasts',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 0,
      yes_rsvp_count: 13,
      duration: 7200000,
      time: 1560272400000,
      utc_offset: 7200000,
      name: 'Workshop: Get loose with Improv Theater',
      id: 'zkrdzqyzjbpb'
    },
    {
      created: 1552730271000,
      duration: 10800000,
      id: '259817783',
      name: '2. Agiles Projektmanagement Trendforum am 27.Juni 2019 (WERK1 München)',
      rsvp_limit: 80,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561654800000,
      local_date: '2019-06-27',
      local_time: '19:00',
      updated: 1553721073000,
      utc_offset: 7200000,
      waitlist_count: 64,
      yes_rsvp_count: 80,
      venue: {
        id: 26052503,
        name: 'WERK1 München',
        lat: 48.123779296875,
        lon: 11.608209609985352,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1430647334000,
        name: 'Projektmanagement Meetup Roundtable',
        id: 18574027,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Projektmanagement-Meetup-Roundtable',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Projektmanagement-Meetup-Roundtable/events/259817783/',
      description: '<p>2. Agiles Projektmanagement Trendforum / Meetup am Donnerstag, den 27. Juni 2019 bei WERK1, München</p> <p>Referenten:<br/>Herr Andreas Hock:<br/>Partner, 3Pworx GmbH, seit ca. 20 Jahren zertifizierter Trainer und Berater für klassisches, agiles und hybrides Projekt- und Portfoliomanagement, PM-Publizist und Buchautor, Erfolgscoach, Motivator und Wissensmanager.</p> <p>Herr Steffen Jakob:<br/>Steffen Jakob ist Diplom-Wirtschaftsingenieur und leitet seit 2013 den Geschäftsbereich Projekt- und Requirements-Management der Haufe Gruppe. In dieser Funktion verantwortet er das Haufe-Projektportfolio.<br/>Er begann seine Karriere bei einem großen internationalen Medienunternehmen und arbeitete anschließend in unterschiedlichen Führungsfunktionen bei IT-Beratungsunternehmen.</p> <p>Herr Timo Bass:<br/>Timo Bass leitet den Bereich Strategische Projektportfolio Steuerung @ CreditPlus (Credit Agricole). Er ist PMP nach PMI, SAFe Program Consultant (SPC), Design Thinking Coach und war früher u.a. für das Beratungshaus Accenture Strategy erfolgreich tätig.</p> <p>Agenda:<br/>18:00 Uhr - Empfang, Get-Together I mit Drinks und Snacks sowie erstes Kennenlernen</p> <p>19:00 Uhr - Begrüßung und Einführung durch 3Pworx GmbH, WERK1</p> <p>19:15 Uhr – Vortrag 1: -&gt; „Vom Religionskrieg zur Ökumene“ – klassische und agile Vorgehensweisen bei der Haufe-Group</p> <p>Vortrag Haufe-Group von Herrn Steffen Jakob</p> <p>20:00 Uhr – Vortrag 2: Eine gemeinsame Reise zu einer Lean &amp; Agile Organisation – Mehr eine Revolution als Transformation!</p> <p>Vortrag von Credit Plus Bank, Herr Timo Bass (Leiter Strategische Portfoliosteuerung)</p> <p>21:00 Uhr – Vortrag 3: Agile Methoden im Vergleich – Scrum vs. KANBAN vs. SAFe, usw.</p> <p>Wie finde ich die „richtige“ agile Methodik, welche idealerweise zu meinem Unternehmen und agilen Projekten passt.</p> <p>Vortrag von Herrn Andreas Hock, Partner 3Pworx GmbH</p> <p>21:30 Uhr - Gemütliches Ausklingen in der Werk1 Lounge mit Snacks &amp; Drinks</p> <p>ca. 22:00 Uhr - Ende des 3Pworx 2. Agilen Trendforums Juni 2019</p> <p>Selbstverständlich ist diese Veranstaltung für Sie kostenfrei.</p> <p>Genaue Veranstaltungsdetails:<br/>Termin: Donnerstag, den 27. Juni 2019; Zeit 18:00 – ca. 22:00 Uhr<br/>Ort: WERK1</p> <p>Anmeldung:<br/>Bitte senden Sie uns Ihre Teilnehmerdaten über das Anmeldeformular auf www.3pworx.com oder senden Sie eine kurze Email an [masked] . Eine Anmeldung ist auch über das XING – Event oder die Meetup-Gruppe möglich.</p> <p>Gerne können Sie die Einladung, wenn Sie möchten, auch an Kolleginnen oder Kollegen sowie Interessierte des PM Meetups 2019 weiterleiten oder weiterempfehlen.<br/>Mit freundlichen Grüßen<br/>Ihr 3Pworx-Team</p> ',
      how_to_find_us: 'https://www.werk1.com',
      visibility: 'public'
    },
    {
      created: 1548946504000,
      duration: 27000000,
      id: '258560164',
      name: 'Global DevOps Bootcamp 2019',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560582000000,
      local_date: '2019-06-15',
      local_time: '09:00',
      rsvp_open_offset: 'PT230H',
      updated: 1558893474000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 35,
      group: {
        created: 1397242023000,
        name: 'Agile Munich',
        id: 13860382,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'AgileMunich',
        who: 'Agile Practitioners',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/AgileMunich/events/258560164/',
      description: '<p>As with previous two years, we\'re bringing you this year\'s Global DevOps Bootcamp on June 15th. Stay tuned and mark your calendars...</p> <p>Get in touch if you wish to sponsor.</p> <p>More details to follow shortly.</p> ',
      visibility: 'public'
    },
    {
      local_time: '19:00',
      local_date: '2019-06-11',
      link: 'https://www.meetup.com/Munich-Girl-Gone-International/events/260951648/',
      visibility: 'public_limited',
      group: {
        created: 1380914527000,
        name: 'Munich Girl Gone International',
        id: 10552542,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-Girl-Gone-International',
        who: 'Girls Gone International',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 11,
      yes_rsvp_count: 16,
      duration: 7200000,
      time: 1560272400000,
      utc_offset: 7200000,
      name: 'GGI Book Club - June: Hunger by Knut Hamsun',
      id: '260951648'
    },
    {
      created: 1559750276000,
      duration: 7200000,
      id: '262067176',
      name: 'Einführung in die XR/AR/VR - Entwicklung',
      rsvp_limit: 50,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1562169600000,
      local_date: '2019-07-03',
      local_time: '18:00',
      updated: 1559750299000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 13,
      venue: {
        id: 25766821,
        name: 'medialesson - Büro München',
        lat: 48.153099060058594,
        lon: 11.583580017089844,
        repinned: true,
        address_1: 'Leopoldstr. 8-10',
        address_2: 'c/o Nutrion Coworking Space',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1520252901000,
        name: 'Software, Technology & Design Meetup München',
        id: 27731423,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Software-Technology-Meetup-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Software-Technology-Meetup-Munchen/events/262067176/',
      description: '<p>Was wir unternehmen werden: Weiter geht’s in diesem Jahr mit spannenden Meetups in den Büroräumen unseres Sponsors medialesson in München! Dieses ist unser drittes Meetup in diesem Jahr und ersetzt das leider ausgefallene Meetup zum selben Thema vom Mai.</p> <p>Wir widmen uns heute einem Thema, das für viele Software-Entwickler, die sich mit der Gestaltung benutzerfreundlicher und innovativer Frontends befassen, sicherlich von großer Bedeutung ist: Wie kann ich mit Virtual, Augmented und Mixed Reality die User Experience verbessern und für mobile Anwendungen im Raum neuartige Darstellungsmethoden umsetzen?</p> <p>Und hier zu allererst: Welche Grundlagen und Tools gehören zur VR-/AR-App-Entwicklung? Dino Fejzagic, Mixed Reality-Entwickler bei der medialesson GmbH, stellt in seinem Vortrag die VR- und AR-App-Entwicklung in vielen ihrer Facetten vor und beschreibt, mit welchen Tools gute Ergebnisse erreicht werden können. Auch demonstriert Dino einige Mixed Reality-Apps in praktischen Beispielen. In einer anschließenden Diskussionsrunde, wollen wir uns gemeinsam der Frage widmen, wohin uns diese Reise noch führen kann.</p> <p>Dieses Meetup richtet sich an Software-Entwickler und IT-Architekten, die einen ersten Einstieg in die VR-/AR-Software-Entwicklung finden möchten.</p> <p>-.-.-</p> <p>Agenda</p> <p>18:00 Uhr - 18:30 Uhr: Kennenlernen bei Pizza und Kaltgetränken</p> <p>18:30 Uhr - 20:00 Uhr: Vortrag Dino Fejzagic mit praktischen Beispielen</p> <p>20:00 Uhr - 20:30 Uhr (oder länger, je nach Interesse): Offene Runde / Diskussion</p> <p>Falls jemand einen weiteren Vortrag zum Thema beisteuern möchte, wäre dies im Anschluss an den ersten Vortag möglich. Genügend Zeit für die Diskussionsrunde ist eingeplant. Meldet euch gerne einfach bei Dino!</p> <p>Catering: Pizza und Getränke werden auch diesmal von medialesson gesponsert. Vielen Dank dafür!</p> ',
      how_to_find_us: 'Eingang über Treppe ins Gebäude Leo 8 und dann die Wendeltreppe hinunter ins Basement. Erste Glastür rechts "Nutrion".',
      visibility: 'public'
    },
    {
      created: 1558552468000,
      duration: 10800000,
      id: '261681541',
      name: '₿🗣️ Thoughts on The Future of Programmable Money',
      rsvp_limit: 300,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561654800000,
      local_date: '2019-06-27',
      local_time: '19:00',
      updated: 1559410554000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 253,
      venue: {
        id: 26405033,
        name: 'TUM Stammgelände',
        lat: 48.14910125732422,
        lon: 11.567317008972168,
        repinned: true,
        address_1: 'Arcisstraße 21',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1372415991000,
        name: 'Bitcoin Munich',
        id: 9128392,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Bitcoin-Munich',
        who: 'Bitcoiners',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Bitcoin-Munich/events/261681541/',
      description: '<p>Author, speaker and educator Andreas M. Antonopoulos comes to Munich to share his thoughts on the future of programmable money.</p> <p>Target Audience: Andreas\' talks are usually very accessible to newcomers, but also valuable for experienced professionals in the field. He communicates the big picture, while gladly addressing deep technical questions.</p> <p>—</p> <p>Andreas M. Antonopoulos is a best-selling author, speaker, educator, and one of the world’s foremost bitcoin and open blockchain experts. He is known for delivering electric talks that combine economics, psychology, technology, and game theory with current events, personal anecdote, and historical precedent effortlessly transliterating the complex issues of blockchain technology out of the abstract and into the real world.</p> <p>In 2014, Antonopoulos authored the groundbreaking book, Mastering Bitcoin (O’Reilly Media), widely considered to be the best technical guide ever written about the technology. His second book, The Internet of Money, unveiled the “why” of bitcoin—and became a bestseller on Amazon— and led to the wildly successful follow-up The Internet of Money Volume Two. His fourth book, Mastering Ethereum (O’Reilly Media) was published in December of 2018.</p> <p>He is a teaching fellow with the University of Nicosia, serves on the Oversight Committee for the Bitcoin Reference Rate at the Chicago Mercantile Exchange, and has appeared as an expert witness in hearings around the world, including the Australian Senate Banking Committee and the Canadian Senate Commerce, Banking and Finance Committee.</p> <p>—</p> <p>- <a href="https://antonopoulos.com" class="linkified">https://antonopoulos.com</a><br/>- <a href="https://twitter.com/aantonop" class="linkified">https://twitter.com/aantonop</a><br/>- Mastering Bitcoin (German): <a href="https://amzn.to/2JzAX5x" class="linkified">https://amzn.to/2JzAX5x</a><br/>- Internet of Money v1 (EN): <a href="https://amzn.to/2VUC1Y1" class="linkified">https://amzn.to/2VUC1Y1</a><br/>- Internet of Money v2 (EN): <a href="https://amzn.to/2Jb8xiS" class="linkified">https://amzn.to/2Jb8xiS</a><br/>- Internet of Money v1 (German): <a href="https://amzn.to/2LEiyqO" class="linkified">https://amzn.to/2LEiyqO</a><br/>- Internet of Money v2 (German): <a href="https://amzn.to/2VCzse5" class="linkified">https://amzn.to/2VCzse5</a><br/>- Mastering Ethereum (English): <a href="https://amzn.to/2J92LOr" class="linkified">https://amzn.to/2J92LOr</a><br/>- Mastering Ethereum in German: <a href="https://amzn.to/2DV6lHS" class="linkified">https://amzn.to/2DV6lHS</a></p> <p>Agenda:<br/>19:00 Doors<br/>19:30 Talk<br/>20:00 Q&amp;A<br/>20:30 Meet &amp; Greet<br/>There will be a book signing, you can bring one of your copies.</p> <p>Food and drinks will likely *not* be available this time.<br/>You can bring your own, but please also take it back home.</p> <p>This event is brought to you by the Bitcoin Community Munich in cooperation with the TUM Blockchain Research Cluster. <a href="https://www.blockchain.tum.de" class="linkified">https://www.blockchain.tum.de</a></p> <p>Location:<br/>Technische Universität München<br/>Stammgelände Thierschbau, 02<br/>Campus München<br/>Arcisstr. 21 (0503), 2. Obergeschoß<br/>Raum 2300 (Raum-Code[masked])<br/>Friedrich von Thiersch Hörsaal<br/><a href="https://www.ph.tum.de/about/visit/roomfinder/?room=0503.02.300" class="linkified">https://www.ph.tum.de/about/visit/roomfinder/?room=0503.02.300</a></p> <p>Subject to changes or additions.</p> <p>(Our meetup group is organized by independent enthusiasts and not affiliated with venues, sponsors, or external speakers of this or past events. Views expressed by them do not necessarily represent our own. We aim to educate i.a. by putting forward the various viewpoints and opinions in the crypto-currency and blockchain space, encouraging discussions to enable everyone to make up their own minds. In particular, our program is not to be understood as investment advice.)</p> ',
      how_to_find_us: 'Raum 2300 (Raum-Code 0503.02.300), Friedrich von Thiersch Hörsaal.\nBest use the entrance at across Gabelsbergerstraße 47 and go to the second floor. https://www.ph.tum.de/about/visit/roomfinder/?room=0503.02.300\n',
      visibility: 'public'
    },
    {
      created: 1548145574000,
      duration: 7200000,
      id: '258288737',
      name: 'Wie Sie Projekt- und Portfolioberichte einfach und effizient erstellen',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561654800000,
      local_date: '2019-06-27',
      local_time: '19:00',
      updated: 1548145574000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 15,
      venue: {
        id: 25697058,
        name: 'Schuhbecks Orlando Lounge ',
        lat: 48.13831329345703,
        lon: 11.580145835876465,
        repinned: true,
        address_1: 'Platzl 4  ',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1516184773000,
        name: 'Project Management Office Stammtisch München - PMO-Meetup',
        id: 27185043,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Project-Management-Office-Stammtisch-Munchen-PMO-Meetup',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Project-Management-Office-Stammtisch-Munchen-PMO-Meetup/events/258288737/',
      description: '<p>Die Ansprüche an ein Berichtswesen zu Projekten und Portfolios sind nicht zu unterschätzen. Was ist wirklich nötig? Weniger ist hier oft mehr. Schnell sind verantwortliche Personen mit der Aufgabenstellung, dem Aufwand und der Konsistenz der Informationen aber überfordern. Was Sie beachten sollten, um Berichte als Kernaufgabe des Projektmanagements möglichst einfach und effizient zu bewerkstelligen, darum geht es an diesem Abend.</p> <p>Nach einer kurzen Einführung sammeln die Teilnehmer in Arbeitsgruppen Ideen. Diese werden dann gemeinsam präsentiert und diskutiert. Tauschen Sie sich intensiv mit Ihren Peers aus und erweitern Sie Ihr Netzwerk. Jetzt gleich kostenlos anmelden.</p> <p>Achtung, die Plätze sind begrenzt. Bitte unbedingt vorher kostenlos anmelden unter <a href="https://www.theprojectgroup.com/pmo-stammtisch" class="linkified">https://www.theprojectgroup.com/pmo-stammtisch</a></p> <p>Und noch was: Werfen Sie unbedingt auch einen Blick auf das Programm unserer kostenlosen Webinare. Das Programm wird laufend aktualisiert: <a href="https://www.theprojectgroup.com/webinar" class="linkified">https://www.theprojectgroup.com/webinar</a></p> ',
      how_to_find_us: 'Bitte unbedingt vorher kostenlos anmelden unter https://www.theprojectgroup.com/pmo-stammtisch',
      visibility: 'public'
    },
    {
      created: 1556879923000,
      duration: 14400000,
      id: '261132297',
      name: 'Lightning Talks Munich',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560015900000,
      local_date: '2019-06-08',
      local_time: '19:45',
      updated: 1556879990000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 111,
      venue: {
        id: 26366088,
        name: 'Das Provisorium',
        lat: 48.12763214111328,
        lon: 11.601123809814453,
        repinned: false,
        address_1: 'gravelottestraße 7',
        city: 'München ',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1502783872000,
        name: 'Lightning Talks Munich',
        id: 25491250,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Lightning-Talks-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Lightning-Talks-Munich/events/261132297/',
      description: '<p>⚡️.🎤</p> <p>Be a part of conversations that come alive with our growing community of the most diverse minds around.</p> <p>Is there a topic that you are passionate about? Working on a cool thesis? Or would you like to share an inspiring experience? That might spark up new ideas, feelings and curiosity?</p> <p>Hold a 5-minute ⏳ Lightning Talk ⚡ followed by a 5-minute Q&amp;A - To Inform, Inspire &amp; Ignite !</p> <p>***** ARE YOU IN? *****<br/>Apply for a spot as soon as possible via Email to [masked] with a short description of what you will talk about. 💌</p> <p>We\'ll join forces to prepare the talk along with a rehearsal where you\'d get to know the other speakers as well!</p> <p>Language: English (recommended) or German</p> <p>***** 𝗙𝗢𝗢𝗗 &amp; 𝗗𝗥𝗜𝗡𝗞𝗦 *****<br/>Beer, Longdrinks &amp; Snacks ( 3€ - 8€)</p> <p>***** 𝗚𝗢𝗢𝗗 𝗧𝗢 𝗞𝗡𝗢𝗪 *****<br/>All Talks will be recorded in order to capture this amazing event! After the intellectual overkill we head to a party or bar to continue the networking. 🍸 😎</p> <p>***** 𝗣𝗜𝗖𝗦 &amp; 𝗩𝗜𝗗𝗘𝗢𝗦 *****<br/><a href="https://www.facebook.com/LTMunich/" class="linkified">https://www.facebook.com/LTMunich/</a></p> <p><a href="https://www.youtube.com/channel/UCoiCuNxXXja8ig8HVJ6pBvw" class="embedded">https://www.youtube.com/channel/UCoiCuNxXXja8ig8HVJ6pBvw</a></p> ',
      how_to_find_us: 'Ostbahnhof (S-bahn, U-bahn)',
      visibility: 'public'
    },
    {
      created: 1539163819000,
      duration: 10800000,
      id: 'qbgmjqyzjbqb',
      name: 'Designer-Stammtisch',
      rsvp_limit: 30,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560358800000,
      local_date: '2019-06-12',
      local_time: '19:00',
      updated: 1539163819000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 21,
      venue: {
        id: 25680781,
        name: 'Mirror Bar Munich',
        lat: 48.16197967529297,
        lon: 11.589398384094238,
        repinned: true,
        address_1: 'Occamstraße 7',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1444668795000,
        name: 'Münchner Designer-Stammtisch',
        id: 19020346,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Designer-Stammtisch',
        who: 'Designer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Designer-Stammtisch/events/qbgmjqyzjbqb/',
      description: '<p>Liebe DesignerInnen,</p> <p>wir treffen uns jeden 2. Mittwoch im Monat um 19:00 Uhr in der Mirror Bar.</p> <p>Bringt eure Erfolge, neusten Projekte oder auch kleinen Problemchen mit und teilt sie mit anderen Designern bei einem entspannten Abendessen.</p> <p>Wir freuen uns auf neue Designer und alte Bekannte, und auf einen gemütlichen Abend mit Designer-Kaltsch-und-Tratsch.</p> <p>Lieben Gruß, Ben</p> <p>ps: für alle die gerne länger unterwegs sind finden wir auch diesmal bestimmt wieder eine Location.</p> <p>pps: We mostly chat in German, but English will work just find as well.</p> ',
      how_to_find_us: 'Fragt nach dem Designerstammtisch dort! *** Please ask for the Designerstammtisch there!',
      visibility: 'public'
    },
    {
      created: 1553800423000,
      duration: 12600000,
      id: '260153576',
      name: 'Independence Flutter Study Jam',
      rsvp_limit: 70,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1562256000000,
      local_date: '2019-07-04',
      local_time: '18:00',
      updated: 1558776630000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 39,
      venue: {
        id: 26041200,
        name: 'SinnerSchrader Deutschland GmbH',
        lat: 48.15207290649414,
        lon: 11.583761215209961,
        repinned: true,
        address_1: 'Schackstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1543101111000,
        name: 'Flutter Munich',
        id: 30587470,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Flutter-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Flutter-Munich/events/260153576/',
      description: '<p>I’d like to invite all of you to our first-ever study jam/coding night. It’s going to be a very laid-back event, with great conversations, drinks, and food. The concept is simple: we meet and we build beautiful apps together.</p> <p>Flutter is Google’s portable UI toolkit to build beautiful native apps on iOS and Android from a single codebase. Flutter Study Jams are a great opportunity to get together to learn and practice this technology in person.</p> <p>👨\u200d💻We prepared a list of awesome tutorials, so you can create something on your own, all the while we are there to help you in case you get stuck.<br/>🐧You can also bring your own ideas or work on open-source projects.<br/>❓You can come with questions, we’ll do our best to help you with any issue you bring.<br/>🎤At the end of the event, you’ll have the opportunity to show to the rest of us what you worked on (presenting is optional, but encouraged).</p> <p>I highly recommend you complete the Flutter installation guide and the Test drive before the event. Installing everything (Xcode, Android Studio, emulators, simulators, enabling development mode on your phone) can take some time, especially if you are doing it the first time. You can get the most out of this event if you successfully run the Flutter example app (click on floating action button to increment counter) on either an emulator/simulator or on a physical device. If you have Flutter installed on your computer, check your version and upgrade if necessary.</p> <p>IMPORTANT</p> <p>💻You need to bring your own computer.<br/>📱Bring cables to connect your phone to your laptop, if you’d like to develop on a physical device (aka mobile phone).<br/>⚡Don’t forget your charger.<br/>👩\u200d💻Finish the Installation Guide before the event. <a href="https://flutter.dev/docs/get-started/install" class="linkified">https://flutter.dev/docs/get-started/install</a><br/>🏎Finish the Test drive before the event. <a href="https://flutter.dev/docs/get-started/test-drive" class="linkified">https://flutter.dev/docs/get-started/test-drive</a></p> <p>LOCATION</p> <p>📍The event\'s location, food, and drinks are provided by SinnerSchrader Deutschland GmbH</p> <p>CONTRIBUTE</p> <p>🗣️ If you would like to share your story with Flutter, contact me! I\'m already organizing the next events and we have slots for speakers.</p> <p>🍕 Would your company like to host one of our upcoming events? Send me a message!</p> ',
      how_to_find_us: 'Follow the "Flutter Meetup" signs to find us. If you have issues finding us, send us a message.',
      visibility: 'public'
    },
    {
      created: 1558019345000,
      duration: 10800000,
      id: '261512891',
      name: 'SEO Meetup München #8',
      rsvp_limit: 50,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560445200000,
      local_date: '2019-06-13',
      local_time: '19:00',
      updated: 1558019345000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 50,
      venue: {
        id: 25724186,
        name: 'One Advertising GmbH',
        lat: 48.13747787475586,
        lon: 11.606467247009277,
        repinned: false,
        address_1: 'Lucile-Grahn-Straße 39',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1521204698000,
        name: 'SEO Meetup München',
        id: 27846414,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'SEO-Meetup-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/SEO-Meetup-Munchen/events/261512891/',
      description: '<p>Liebe SEO-Begeisterte,</p> <p>SEO Meetup München lädt zum 8. Mal in die Lucile-Grahn-Straße ein.<br/>Speichert euch schon mal das Datum ein, weitere Infos zum Vortrag folgen.</p> <p>Wir freuen uns auf euch. Für Bier&amp;Wein sowie Verpflegung ist wie immer gesorgt. :)</p> <p>Eurer SEO Meetup München Team</p> ',
      visibility: 'public'
    },
    {
      created: 1557345619000,
      duration: 10800000,
      id: '261297713',
      name: 'Munich Frontend Developers Meetup Summer Edition',
      rsvp_limit: 160,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560357000000,
      local_date: '2019-06-12',
      local_time: '18:30',
      updated: 1558426044000,
      utc_offset: 7200000,
      waitlist_count: 21,
      yes_rsvp_count: 160,
      venue: {
        id: 26377974,
        name: 'xbAV AG',
        lat: 48.14632034301758,
        lon: 11.537505149841309,
        repinned: true,
        address_1: 'Arnulfstraße 126',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1413460221000,
        name: 'Munich Frontend Developers',
        id: 17660862,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-Frontend-Developers',
        who: 'Frontend Developers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munich-Frontend-Developers/events/261297713/',
      description: '<p>Welcome to Fronted Developers Meetup Summer edition!<br/>This time we will be hosted by awesome guys from xbAV AG (www.xbav.de)</p> <p>• Doors open at 18:30 and we start with soft drinks, beer</p> <p>• Talks start at 19:00<br/>• Raffaele Pizzari "Don\'t make fun of JavaScript"<br/>Description: "Probably JavaScript is one of the world\'s most misunderstood lang. So let\'s talk about some of the most famous jokes, the critics and the misconceptions<br/>about JS and try to demystify them."</p> <p>• Paul Janicki "Extracting a standalone UI library from a monolithic web application"</p> <p>• Open End</p> <p>See you there!</p> ',
      visibility: 'public'
    },
    {
      created: 1550042513000,
      duration: 10800000,
      id: '258922151',
      name: '104. JUG-München Treffen',
      rsvp_limit: 30,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1563379200000,
      local_date: '2019-07-17',
      local_time: '18:00',
      updated: 1550042513000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 25942014,
        name: 'Wirtshaus zum Isartal',
        lat: 48.112571716308594,
        lon: 11.553250312805176,
        repinned: true,
        address_1: 'Brudermühlstrasse 2',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1537211427000,
        name: 'Joomla User Group München',
        id: 29852639,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Joomla-User-Group-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Joomla-User-Group-Munchen/events/258922151/',
      description: '<p>Komm zum JUG-München Treffen und…</p> <p>- lerne nette Leute kennen, die sich mit Joomla! beschäftigen<br/>- tausche Dich in lockerer Umgebung beim Stammtisch mit Gleichgesinnten aus<br/>- erhalte Hilfe zur Selbsthilfe und stelle Fragen an andere User und Profis<br/>- höre Dir Vorträge über und rund um Joomla! an oder halte selbst welche<br/>- nimm an Workshops teil oder vielleicht magst Du selbst einen veranstalten?<br/>- teile Dein Wissen und Deine Erfahrungen mit Joomla! oder Erweiterungen<br/>- erfahre aktuelle Informationen aus erster Hand rund um Joomla! oder Joomla!-Events<br/>- profitiere von unseren tollen Lokations und melde Dich heute noch zum Treffen an</p> ',
      visibility: 'public'
    }
  ]
};
export { mockEvents };